import React from 'react';
import { Link } from "react-router-dom";

function WelcomeBig() {
  return (

    <section className="section-1">
        <div className="jumbotron d-flex align-items-center">
            <div className="gradient"></div>
            <div className="container-fluid content">
                <h1 data-aos="fade-up" data-aos-delay="100">Bem Vindo ao LINA</h1>
                <h2 data-aos="fade-up" data-aos-delay="300">Laboratório de INteligência Artificial da UFPI</h2>
                <h4 data-aos="fade-up" data-aos-delay="500">Pesquisa e Inovação através de soluções em Inteligência Artificial</h4>
                <p data-aos="fade-up" data-aos-delay="700">
                    <Link to="/About" className="btn btn-success">Quem Somos</Link>
                </p>
                
            </div>
            
        </div>
    </section>

  );
}

export default WelcomeBig;
;